var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextInput',{attrs:{"props":_vm.input_props,"required_rule":_vm.required_rule},on:{"update":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }